import { render, staticRenderFns } from "./ServidorPublicoSP.vue?vue&type=template&id=043df6ad"
import script from "./ServidorPublicoSP.vue?vue&type=script&lang=js"
export * from "./ServidorPublicoSP.vue?vue&type=script&lang=js"
import style0 from "./ServidorPublicoSP.vue?vue&type=style&index=0&id=043df6ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports